import { Component, computed, linkedSignal, OnInit, signal } from '@angular/core';
import { TuiDialogContext, TuiScrollbar } from '@taiga-ui/core';
import { LayerDTO } from '../../data-access/feature-layers.service';
import { injectContext } from '@taiga-ui/polymorpheus';
import { ExtendedLayerDTO } from '../create-scenario/create-scenario.component';
import { filter, map } from 'rxjs';
import { Result } from 'ts-results';
import { CloneFeatureLayerComponent } from '../clone-feature-layer/clone-feature-layer.component';
import { CloneFeatureLayerRequest } from '../create-feature-layer/create-feature-layer.component';
import { Prettify } from 'src/app/shared/features/esk-tool/util';
import { FormsModule } from '@angular/forms';
import { TuiCheckbox } from '@taiga-ui/kit';

@Component({
  selector: 'clone-feature',
  styleUrls: ['./clone-feature.component.css'],
  imports: [FormsModule,TuiScrollbar,TuiCheckbox],
  template: `
  <form>

<section class="sticky top-0 bg-white z-10">
  <p class="text-xs text-gray-600 mb-6 leading-relaxed break-words whitespace-normal text-justify max-w-[50ch]">
    Pick a list of layers to clone this feature to.
  </p>

  <div class="flex items-center justify-start py-2.5 font-bold border-b border-gray-300">
    <label class="flex items-center gap-2">
      <input
      tuiCheckbox
      type="checkbox"
      [indeterminate]="indeterminate()"
      [ngModel]="allSelected()"
      (ngModelChange)="toggleSelectAll($event)"
      [ngModelOptions]="{standalone: true}"
    />
    Layers

    </label>
  </div>

</section>


  <tui-scrollbar>
    <div overflowPadding class="max-h-[400px]">
      @for(layer of test(); track layer.layerID)
      {
        <div class="flex items-center justify-start py-2.5 border-b border-gray-200">
        <div class="flex-1 flex items-center gap-2 justify-between">

          <label class="flex items-center gap-2">
            <input
            tuiCheckbox
            type="checkbox"
            [ngModel]="layer.isSelected"
            (ngModelChange)="updateRow(layer.layerID, {isSelected: $event})"
            [ngModelOptions]="{standalone: true}"
          />
            {{ layer.name }}

          </label>
        </div>
      </div>
      }
    </div>
  </tui-scrollbar>

</form>

<div class="p-2 flex justify-end">
<button
    class="bg-gray-300 hover:bg-gray-400 text-gray-700 py-2 px-4 rounded mr-2"
    (click)="onNoClick()"
  >
    Cancel
  </button>
  <button
    class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded disabled:bg-blue-300 disabled:cursor-not-allowed"
    (click)="onYesClick()"
  >
    Confirm
  </button>
    </div>

  `

})
export class CloneFeatureComponent {


  public readonly context = injectContext<TuiDialogContext<number[], {layers: LayerDTO[]}>>();

  propertyLayers = signal(this.context.data.layers);

  allSelected = computed(() => {
    const items = this.test();
    const total = items.length;
    const selectedCount = items.filter(i => i.isSelected).length;

    return selectedCount === total && total > 0;
  });

  test = linkedSignal<Prettify<LayerDTO & {isSelected: boolean}>[]>(
    () => {
      const propertyLayers = this.propertyLayers();

      return propertyLayers.map(layer => ({
        ...layer,
        isSelected: false,
      }))
    }

  )

  indeterminate = computed(() => {
    const items = this.test();
    const total = items.length;
    const selectedCount = items.filter(i => i.isSelected).length;
    return selectedCount >= 2 && selectedCount < total;
  });

  submitModel = computed(() => {
  const rows = this.test();

  return rows.filter(row => row.isSelected).map(({layerID}) => (layerID))
  })

  toggleSelectAll(selected:boolean)
  {
    const items = this.test();


    const updatedItems = items.map(item => ({
      ...item,
      isSelected: selected,
    }));

    this.test.set(updatedItems);
  }

  updateRow(layerID: number, payload: Partial<ExtendedLayerDTO>) {

  const items = this.test();


  const index = items.findIndex(e => e.layerID === layerID);


  if (index !== -1) {
    const updatedItem = { ...items[index], ...payload };

    const updatedItems = [
      ...items.slice(0, index),
      updatedItem,
      ...items.slice(index + 1)
    ];

    this.test.set(updatedItems);

  }
}

onCloneToggle(layer:ExtendedLayerDTO,shouldClone:boolean)
{

      this.updateRow(layer.layerID, {shouldClone});


}


  constructor() {}

  onNoClick(): void {
    this.context.$implicit.complete();
  }

  onYesClick(): void {
    this.context.completeWith(this.submitModel());
  }


}
